<template>
  <iColumn align="center">
    <iColumn v-if="forcedEnrollBackupCodes.length > 0" align="center">
      <iText>
        Two-factor authentication is on. Save these one-time backup codes — they are your only way
        in if you lose your other methods, and they will not be shown again.
      </iText>
      <iText v-for="backupCode in forcedEnrollBackupCodes" :key="backupCode" font-weight="dark">
        {{ backupCode }}
      </iText>
      <iButton :is-loading="isLoading" @click="finishForcedEnroll">
        I've saved my backup codes — continue
      </iButton>
    </iColumn>

    <iColumn v-else-if="method === null" align="center">
      <iText>Your account requires two-factor authentication. Choose how you'd like to secure it.</iText>
      <iButton :is-loading="isLoading" @click="chooseTotp">
        Use an authenticator app
      </iButton>
      <iButton
        variant="secondary"
        left-icon="key"
        :is-loading="isLoading"
        @click="choosePasskey"
      >
        Use a passkey
      </iButton>
      <iText v-if="twoFactorErrorMessage" variant="error">
        {{ twoFactorErrorMessage }}
      </iText>
    </iColumn>

    <iColumn v-else-if="method === 'totp'" align="center">
      <iText>Scan this QR code with your authenticator app, then enter the 6-digit code.</iText>
      <iImageContainer
        v-if="forcedEnrollQrDataUri"
        :src="forcedEnrollQrDataUri"
        alt="Authenticator QR code"
        :width="200"
        :height="200"
      />
      <iText v-if="forcedEnrollSecret" font-weight="dark">
        {{ forcedEnrollSecret }}
      </iText>
      <iTextInput
        v-model="code"
        width="fill"
        focus
        @enter="submitConfirm"
      />
      <iText v-if="twoFactorErrorMessage" variant="error">
        {{ twoFactorErrorMessage }}
      </iText>
      <iButton :is-loading="isLoading" :disabled="isLoading || hasInvalidCode" @click="submitConfirm">
        Verify and continue
      </iButton>
      <iLink @click="resetChoice">
        Choose a different method
      </iLink>
    </iColumn>

    <iColumn v-else align="center">
      <iText>Give this passkey a name, then follow your browser's prompt to register it.</iText>
      <iTextInput
        v-model="passkeyAlias"
        width="fill"
        focus
        @enter="submitPasskey"
      />
      <iText v-if="twoFactorErrorMessage" variant="error">
        {{ twoFactorErrorMessage }}
      </iText>
      <iButton :is-loading="isLoading" @click="submitPasskey">
        Register passkey and continue
      </iButton>
      <iLink @click="resetChoice">
        Choose a different method
      </iLink>
    </iColumn>

    <iSpace :height="40" width="fill" />
    <PoweredByInspiration />
  </iColumn>
</template>

<script>
import PoweredByInspiration from "%/dynamic-component-editor/standard-pages/login-signup-page/join-publication/PoweredByInspiration.vue";
import { mapActions, mapState, mapWritableState } from "pinia";
import { useLoginSignupStore } from "%/dynamic-component-editor/stores/login-signup-store";

export default {
  name: "JoinPublicationTwoFactorEnroll",
  components: { PoweredByInspiration },
  data() {
    return {
      method: null,
      code: "",
      passkeyAlias: "",
    };
  },
  computed: {
    ...mapWritableState(useLoginSignupStore, ["twoFactorErrorMessage"]),
    ...mapState(useLoginSignupStore, [
      "isLoading",
      "forcedEnrollSecret",
      "forcedEnrollQrDataUri",
      "forcedEnrollBackupCodes",
    ]),
    hasInvalidCode() {
      return this.code.replace(/\D/g, "").length < 6;
    },
  },
  mounted() {
    this.twoFactorErrorMessage = "";
  },
  methods: {
    ...mapActions(useLoginSignupStore, [
      "enrollForcedTotp",
      "confirmForcedTotp",
      "forcedRegisterPasskey",
      "finishForcedEnroll",
    ]),
    chooseTotp() {
      this.twoFactorErrorMessage = "";
      this.method = "totp";
      this.enrollForcedTotp();
    },
    choosePasskey() {
      this.twoFactorErrorMessage = "";
      this.method = "passkey";
    },
    resetChoice() {
      this.method = null;
      this.code = "";
      this.passkeyAlias = "";
      this.twoFactorErrorMessage = "";
    },
    submitConfirm() {
      if (this.hasInvalidCode) {
        return;
      }
      this.confirmForcedTotp(this.code);
    },
    submitPasskey() {
      this.forcedRegisterPasskey(this.passkeyAlias || "Passkey");
    },
  },
};
</script>

<style scoped lang="scss">

</style>
